import { BusinessError } from './businessError';

/*
 * This error is thrown when a user gets a 423 error and needs additional authorization
 */
export class AdditionalAuthorizationError extends BusinessError {
    public name = 'AdditionalAuthorizationError';
}
